import { render, staticRenderFns } from "./RolesPermisos.vue?vue&type=template&id=8b9877f0&scoped=true"
import script from "./RolesPermisos.vue?vue&type=script&lang=js"
export * from "./RolesPermisos.vue?vue&type=script&lang=js"
import style0 from "./RolesPermisos.vue?vue&type=style&index=0&id=8b9877f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9877f0",
  null
  
)

export default component.exports